import { useMemo } from 'react';
import { MecProduct, PriceGroup } from '@adapters/bigcommerce/types/product';
import { transformProductPrice } from '@utils/comparison/transformProductPrice';

export const useProductPrice = (
  product: MecProduct | undefined | null
): PriceGroup | null => {
  return useMemo(() => {
    if (!product) {
      return null;
    }
    return transformProductPrice(product);
  }, [product]);
};
